import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const UnmuteIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#FDFBF9"
      d="M14.062 19.236v-.974a6.566 6.566 0 0 0 3.228-2.436 6.5 6.5 0 0 0 1.218-3.848 6.484 6.484 0 0 0-1.218-3.839 6.622 6.622 0 0 0-3.228-2.446V4.72a7.943 7.943 0 0 1 3.871 2.788 7.227 7.227 0 0 1 1.498 4.47c0 1.665-.5 3.158-1.498 4.48a7.885 7.885 0 0 1-3.871 2.778Zm-9.493-5.328v-3.816h3.346l3.454-3.454v10.724l-3.454-3.454H4.57Zm9.493 1.338V8.72c.563.357.998.826 1.303 1.408.306.583.458 1.207.458 1.873a3.817 3.817 0 0 1-1.761 3.246Zm-3.616-6.378L8.31 11.015H5.492v1.97H8.31l2.137 2.137V8.868Z"
    />
  </Svg>
)
export default UnmuteIcon
